import type { LucideIcon } from "lucide-react";

interface LinkImage {
	src: string,
	href?: string,
}

interface LinkIcon {
	icon: LucideIcon,
	href?: string,
}

interface Link {
	image?: LinkImage,
	icon?: LinkIcon,
}

export interface LinksProps {
	links: Link[],
}

export default function Links({ links }: LinksProps) {
	return (
		<div className="flex items-center justify-center gap-4 select-none">
			{links.filter((l) => (l.image || l.icon)).map((link, idx) => {
				const Icon = link.icon?.icon;
				return (
					<a
						key={idx}
						href={link.image?.href ?? link.icon?.href}
						className="block w-[20px] h-[20px] will-change-transform transition-transform duration-700 ease-out hover:scale-110 hover:brightness-110">
						{link.image ? (
							<img
								src={link.image.src}
								alt={""}
								className="w-full h-full object-contain"
							/>
						) : Icon ? (
							<Icon className="w-full h-full text-primary" />
						) : null}
					</a>
				);
			})}
		</div>
	);
}
